import React from 'react';
import { Localize } from 'components/service';
import { timeFormat } from "utils/helper-functions";
import GraphicStandFields from '../fields';


const graphicStandColumns = [
    {
        title: <Localize>TABLES.Column_Title_Exhibitor</Localize>,
        dataIndex: 'exhibitor',
        columnIndex: 'EXHIBITOR',
        sorter: true,
        fixed: 'left',
        width: 250,
    },
    {
        title: <Localize>TABLES.Column_Title_Shelf</Localize>,
        dataIndex: 'relStand',
        columnIndex: 'SHELF_NUMBER',
        relation: 'relStand',
        sorter: true,
        width: 115,
    },
    {
        title: <Localize>TABLES.Column_Title_Hall</Localize>,
        dataIndex: 'hall_name',
        columnIndex: 'HALL_NAME',
        sorter: true,
        align: 'center',
        width: 115,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_Corridor</Localize>,
        dataIndex: 'corridor',
        columnIndex: 'CORRIDOR',
        align: 'center',
        width: 115,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_Block</Localize>,
        dataIndex: 'block',
        columnIndex: 'BLOCK',
        sorter: true,
        align: 'center',
        width: 115,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_StandNumber</Localize>,
        dataIndex: 'stand_number',
        columnIndex: 'STAND_NUMBER',
        align: 'center',
        sorter: true,
        width: 115,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_Comment</Localize>,
        dataIndex: 'comment',
        columnIndex: 'COMMENT',
        align: 'center',
        sorter: true,
        width: 150,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_Date</Localize>,
        dataIndex: 'complete_at',
        columnIndex: 'COMPLETE_AT',
        sorter: true,
        width: 150,
    },
    {
        title: <Localize>TABLES.Column_Title_PackedBy</Localize>,
        dataIndex: 'relPackedUser',
        columnIndex: 'UPDATED_AT',
        sorter: true,
        width: 250,
    },
    {
        title: <Localize>TABLES.Column_Title_Label</Localize>,
        dataIndex: 'label',
        columnIndex: 'LABEL',
        width: 80,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_Materials</Localize>,
        dataIndex: 'materials',
        columnIndex: 'MATERIALS',
        width: 80,
        className: 'padding-x-5',
    },
    {
        title: <Localize>TABLES.Column_Title_ReturnWarehouse</Localize>,
        dataIndex: 'return_warehouse',
        columnIndex: 'RETURN_WAREHOUSE',
        align: 'center',
        width: 70,
        className: 'padding-x-5',
        fixed: 'right',
    }
];

const graphicStandData = (model, graphicList, variables) => {
    if (!model)
    {
        return [];
    }

    return model.map((item) => {
        return {
            key: item.id,
            exhibitor: <GraphicStandFields.Title
                id={ item.id }
                title={ item.exhibitor }
                graphicListId={ graphicList?.id }
            />,
            relStand: <GraphicStandFields.Shelf stand={item.relStand} />,
            hall_name: <GraphicStandFields.NewLocation graphicStand={item} field="hall_name" />,
            corridor: <GraphicStandFields.NewLocation graphicStand={item} field="corridor" />,
            block: <GraphicStandFields.NewLocation graphicStand={item} field="block" />,
            stand_number: <GraphicStandFields.NewLocation graphicStand={item} field="stand_number" />,
            comment: <GraphicStandFields.Comment graphicStand={item} field="comment" />,
            complete_at: item.complete_at ? timeFormat(item.complete_at) : <strong>&mdash;</strong>,
            relPackedUser: <GraphicStandFields.PackedUser graphicStand={ item } />,
            label: <GraphicStandFields.Materials graphicStand={ item } />,
            materials: <GraphicStandFields.Graphic stand={item.relStand} />,
            return_warehouse: <GraphicStandFields.ReturnWarehouse graphicStand={item} />,
        };
    });
};

const GraphicStandTableHelper = {
    columns: graphicStandColumns,
    data: graphicStandData,
};

export default GraphicStandTableHelper;